import i18n from './modules/i18n'
import user from './modules/user'
import img from './modules/img'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    i18n,
    user,
    img,
  },
})
